// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"140":"1528a23c7ff2242d","270":"a96f6b27b79bfdd1","717":"554f6f9ce08d077e","796":"19778ded86901a77"}[chunkId] + ".js";
};